import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getReadAloud = (params) => {
	var url = ApiRouters.READALOUD;
	return api.get(url, { params });
};

export const getReadAloudDetail = (id, params) => {
	var url = `${ApiRouters.READALOUD}/${id}`;
	return api.get(url, { params });
};

export const createQuesReadAloud = (body) => {
	var url = ApiRouters.READALOUD;
	return api.post(url, body);
};

export const updateReadAloudDetail = (body) => {
	var url = `${ApiRouters.READALOUD}/${body.get('id')}`;
	return api.put(url, body);
};

export const deleteReadAloud = (id) => {
	var url = `${ApiRouters.READALOUD}/${id}`;
	return api.delete(url);
};
